<template>
  <media-manager
    v-bind:title="'Promotional Media'"
    v-bind:containers="[promotionalContainer]"
    v-bind:defaultContainer="promotionalContainer.name"
    v-bind:disabledContentTypes="['image', 'audio']"
  />
</template>

<script>
import MediaManager from '@/components/MediaManager'
import { Container } from '@/config.js'

export default {
  name: 'GeniePromotionalMediaManager',
  components: {
    MediaManager
  },
  data() {
    return {
      promotionalContainer: {
        name: Container.Promotional,
        displayName: 'Promotional'
      }
    }
  }
}
</script>
